import { useState } from "react";
import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay"
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal"
import { useModal } from "../../contexts/ModalContext";
import useApi from "../../hooks/useApi";
const ModalNewEmail = ({ centro_custo, ano, fecharModal }) => {
    const api = useApi();


    const { closeModal } = useModal();
    const [email, setEmail] = useState('');

    const [loading, setLoading] = useState(false);

    const handleSave = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const { data } = await api.post('/Painel/API/Cipa/NewEmail/', {
                centro_custo,
                ano,
                email: email
            }, { withCredentials: true })

            console.log(data);
            fecharModal();
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="sm" header={true} close={closeModal} >
                    <Formulario onSubmit={handleSave} >
                        <FormComp
                            title="E-MAIL"
                            type="email"
                            valor={email}
                            changeFunc={(e) => setEmail(e.target.value.toLowerCase())}
                            required
                        />
                        <FormComp
                            valor={loading ? "SALVANDO..." : "SALVAR"}
                            type="submit"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNewEmail;